import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import getApi from '../../shared/apiFactory';

import Config from '../../../config';
import agGridConfig from '../../../agGridConfig';

import {
  FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL,
  FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_FAILURE,
} from './types';
import {
  fetchEnabledFlagValues as fetchEnabledFlagValuesApi,
  fetchAccountCodes as fetchAccountCodesApi,
  fetchTaxDescriptionNames as fetchTaxDescriptionNamesApi,
} from '../api';
import { fetchingError } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';
import fixDataTypes from '../xlsxImport/processors/fixDataTypes.processor';
import { columnHeaders } from '../columnHeaders';
import {
  FIELD_MAPPINGS,
  MAX_COLUMNS_NUMBER,
  MIN_COLUMNS_NUMBER,
} from '../xlsxImport/constants';

export const sharedActions = getActions(adminPageNames.TAX_ACCOUNTING, {
  pageTitle: adminPageTitles.TAX_ACCOUNTING,
  api: getApi({
    pageTitle: adminPageTitles.TAX_ACCOUNTING,
    endpoints: {
      FETCH: Config.endpoints.FETCH_TAX_ACCOUNTINGS,
      INSERT: Config.endpoints.ADD_TAX_ACCOUNTING,
      UPDATE: Config.endpoints.UPDATE_TAX_ACCOUNTING,
      DELETE: Config.endpoints.DELETE_TAX_ACCOUNTING,
      VALIDATE: Config.endpoints.VALIDATE_TAX_ACCOUNTING,
      IMPORT: Config.endpoints.SAVE_TAX_ACCOUNTING,
    },
    options: {
      parseResponseErrorWithDetails: true,
    },
  }),
  sortingField: 'taxDescription',
  agGridConfig: agGridConfig.adminTaxAccounting,
  excel: {
    sheetName: 'Tax Accounting',
    lastColumnLetter: 'H',
    dataTypesProcessor: fixDataTypes,
    columnHeaders,
    fieldMappings: FIELD_MAPPINGS,
    minColumnsNumber: MIN_COLUMNS_NUMBER,
    maxColumnsNumber: MAX_COLUMNS_NUMBER,
  },
});

export const fetchInitialDataForTaxAccountingModal = () => async dispatch => {
  dispatch({ type: FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL });
  try {
    const enabledFlagValuesResponse = await fetchEnabledFlagValuesApi();
    const accountCodesResponse = await fetchAccountCodesApi();
    const taxDescriptionNamesResponse = await fetchTaxDescriptionNamesApi();

    return dispatch({
      type: FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_SUCCESS,
      enabledFlagValues: enabledFlagValuesResponse,
      accounts: accountCodesResponse,
      taxDescriptionNames: taxDescriptionNamesResponse,
    });
  } catch (error) {
    dispatch({ type: FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_FAILURE });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};
